<template>
  <div class="index">
    <div class="index-con">
      <div class="big-title">
        <span>{{ $t("submissionsbigtitle") }}</span>
      </div>
      <div class="sub-lists">
        <div class="sub-list">
          <img class="sub-img" src="../../../static/sub-004.png" alt="" />
          <div class="small-title">{{ $t("submissionstitle1") }}</div>
          <div class="text">
            <p v-for="(item, index) in $t('submissdataList')" :key="index">
              {{ item }}
            </p>
          </div>
        </div>
        <div class="sub-list">
          <img class="sub-img" src="../../../static/sub-001.png" alt="" />
          <div class="small-title">{{ $t("submissionstitle2") }}</div>
          <div class="text">
            {{ $t("submissionstext21") }}
            <!--span class="text-red">English</!--span-->.
            <br />
            {{ $t("submissionstext22") }}
            <br />
            {{ $t("submissionstext23") }}
          </div>
        </div>
        <div class="sub-list">
          <img class="sub-img" src="../../../static/sub-002.png" alt="" />
          <div class="small-title">{{ $t("submissionstitle3") }}</div>
          <div class="text">
            <b class="text-red">{{ $t("submissionstext31a") }}</b>
            {{ $t("submissionstext31b") }}<br />
            <b class="text-red">{{ $t("submissionstext32a") }}</b>
            {{ $t("submissionstext32b") }} <br />
            <b class="text-red">{{ $t("submissionstext33a") }}</b>
            {{ $t("submissionstext33b") }}<br />
            <b class="text-red">{{ $t("submissionstext34a") }}</b>
            {{ $t("submissionstext34b") }}
          </div>
        </div>
        <div class="sub-list">
          <img class="sub-img" src="../../../static/sub-003.png" alt="" />
          <div class="small-title">{{ $t("submissionstitle4") }}</div>
          <div class="text">
            {{ $t("submissionstext41") }}
            <p class="text-blue curdis">
              <!--  @click="download(1)" -->
              <img class="icon-word" src="http://music.chinaman.cn/mybigdatas/ids/static/img-020.png" alt="" />
              Abstract_Template_IDS2024.docx
            </p>
            <br />
            {{ $t("submissionstext42") }}
            <p class="text-blue curdis">
              <!--p class="text-blue cup" @click="download(2)"-->
              <img class="icon-word" src="http://music.chinaman.cn/mybigdatas/ids/static/img-020.png" alt="" />
              Full Paper_Template_IDS_IDS2024.docx
            </p>
          </div>
          <div class="small-title">{{ $t("submissionstext43") }}</div>
          <!--div class="text cup" @click="toRegFn">
            <i class="el-icon-upload2 text-blue font-18"></i>
            <span class="text-blue"> {{ $t("submissionstext44") }}</span>
          </！div-->
          <p class="text-blue curdis">
            <i class="el-icon-upload2 text-blue font-18"></i>
            <span class="text-blue"> {{ $t("submissionstext44") }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dataList: [
        "Fundamentals, modeling, and simulation",
        "Physical properties and product quality",
        "Industrial processes and equipment",
        "Measurement and process control",
        "Energy and environmental issues",
        "Osmotic dehydration and drying",
        "Drying of gases and liquids",
        "Drying of powdered solids",
        "Drying in biomass energy applications",
        "Drying of food and agricultural materials",
        "Drying of biological and pharmaceutical materials",
        "Drying of chemicals and polymers",
        "Drying of wood, pulp and paper, forest products",
        "Novel drying technologies, R&D opportunities",
      ],
    };
  },
  methods: {
    toRegFn() {
      this.$router.push("/loginThen");
    },
    download(index) {
      if (index == 1) {
        let href =
          "https://test.iradstm.com/public/uploads/down/Abstract_Template_IDS2024.docx";
        var a = document.createElement("a");
        a.href = href;
        a.download = `Abstract_Template_iradstm.docx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      } else {
        let href =
          "https://www.iradstm.org/public/uploads/down/Full_Paper_Template_IDS_IDS2024.docx";
        var a = document.createElement("a");
        a.href = href;
        a.download = `Manuscript_Template_IDS2024.docx`;
        a.style.display = "none";
        document.body.appendChild(a);
        a.click();
        a.remove();
      }
    },
  },
};
</script>

<style scoped>
.font-18 {
  font-size: 20px;
}

.icon-word {
  width: 25px;
  height: auto;
}

.text-blue {
  color: #428bca;
}

.text-gray {
  color: #7f7f7f;
}

.curdis {
  cursor: no-drop;
}

.title {
  color: #0a9a7a;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  font-weight: 600;
  margin-bottom: 70px;
  margin-top: 50px;
  position: relative;
}

.title::after {
  content: "";
  left: 50%;
  bottom: 0px;
  transform: translateX(-50%);
  width: 140px;
  height: 4px;
  text-align: center;
  background: #0a9a7a;
  position: absolute;
  margin-bottom: -10px;
}

.index-con {
  margin: 0 auto;
  width: 1200px;
  padding-bottom: 170px;
}

.text {
  color: #333;
  /* text-indent: 2em; */
  line-height: 2;
  padding-bottom: 20px;
}

.w-350 {
  width: 350px;
  margin: 0 auto;
  text-indent: 0;
  text-align: center;
}

.small-title {
  font-size: 17px;
  font-weight: 600;
  margin-bottom: 20px;
}

.sub-lists {
  display: flex;
  flex-wrap: wrap;
}

.sub-list {
  width: 50%;
  box-sizing: border-box;
  position: relative;
  padding: 0 20px 40px;
  padding-left: 70px;
}

/* .sub-list:nth-of-type(2n) {
  width: 60%;
} */

.text-red {
  color: rgb(181, 53, 53);
}

.sub-img {
  position: absolute;
  left: 0px;
  top: 0px;
  width: 60px;
  height: auto;
}

@media screen and (max-width: 768px) {
  .index-con {
    width: 100%;
  }

  .nav {
    width: 100%;
  }

  .title {
    font-size: 18px;
  }

  .index {
    padding: 40px 10px 0;
    box-sizing: border-box;
  }

  .sub-lists {
    display: block;
  }

  .sub-list {
    width: 100%;
    box-sizing: border-box;
    position: relative;
    padding: 20px;
    padding-left: 20px;
  }

  .text-red {
    color: rgb(181, 53, 53);
  }

  .sub-img {
    position: relative;
    left: 0;
    top: 0px;
    float: right;
    width: 60px;
    height: auto;
    margin-top: -25px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/login/submissions.vue